<template>
    <button
        class="facebook-sign-in"
        type="button"
        @click.prevent.stop="signIn"
    >
        <img
            class="icon"
            src="@/assets/third-party/facebook.svg"
        />

        <span class="label">
            {{ t('registration.facebook_sign_in') }}
        </span>
    </button>
</template>

<script setup lang="ts">
import { nextTick, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useScriptTag } from '@vueuse/core'
import { useI18n } from 'vue-i18n'

import { useCustomerRegistrationInputStore } from '@/composables/useCustomerRegistrationInput'
import { usefacebookAppId } from '@/plugins/facebook-sign-in-id'

const emit = defineEmits<{
    submit: []
    fail: []
    click: []
}>()

const client_id = usefacebookAppId()
const { t } = useI18n()

const { facebookSignInToken } = storeToRefs(useCustomerRegistrationInputStore())
const initialized = ref(false)

const signIn = () => {
    emit('click')

    if (!initialized.value) {
        return
    }

    FB.login(
        (response) => {
            if (!response) {
                return
            }

            if (response.status === 'connected') {
                if (!response.authResponse) {
                    emit('fail')

                    return
                }
            } else {
                return
            }

            const accessToken = response.authResponse.accessToken

            if (accessToken) {
                facebookSignInToken.value = accessToken

                emit('submit')

                nextTick(() => (facebookSignInToken.value = null))
            } else {
                emit('fail')
            }
        },
        { scope: 'public_profile,email' }
    )
}

if (client_id) {
    useScriptTag(
        `https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v24.0&appId=${client_id}`,
        () => {
            initialized.value = true
        },
        {
            async: true,
        }
    )
}
</script>

<!-- Attention! Unscoped -->
<style lang="scss">
.facebook-sign-in {
    position: relative;
    width: 100%;
    height: 40px;
    border-radius: 20px;
    border: 1px solid $slate;
    background-color: $white;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-family: $effra-font-stack;
    letter-spacing: 0.05em;
    font-size: 1rem;
    font-weight: 400;

    .icon {
        margin-left: 12px;
        width: 18px;
        height: 18px;
    }

    .label {
        display: block;
        width: 100%;
        text-align: center;
    }
}
</style>
